import * as React from 'react';
const SvgYoutubeSkippable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    fill="none"
    viewBox="0 0 88 88"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" fillOpacity={0.01} d="M0 0h88v88H0z" />
      <rect width={88} height={88} fill="#fff" rx={4} />
      <path
        fill="#16E"
        d="M4 28a2 2 0 0 1 2-2h76a2 2 0 0 1 2 2v40a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
        opacity={0.6}
      />
      <rect
        width={79}
        height={43}
        x={4.5}
        y={26.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={1.5}
      />
      <rect
        width={40}
        height={2}
        x={4}
        y={20}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={64}
        height={2}
        x={4}
        y={16}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={12}
        height={2}
        x={14}
        y={9}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={22}
        height={2}
        x={14}
        y={5}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={1}
      />
      <rect
        width={8}
        height={8}
        x={4}
        y={4}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.8}
        rx={2}
      />
      <rect
        width={87}
        height={87}
        x={0.5}
        y={0.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={3.5}
      />
      <path
        fill="#fff"
        d="M38.2 55.611c-.2-.26-.2-.73-.2-1.66v-11.9c0-.93 0-1.4.2-1.66.07-.1.16-.18.26-.24.13-.08.29-.14.46-.15.33-.02.73.23 1.52.74l9.335 5.95c.69.44 1.03.66 1.15.94a1 1 0 0 1 0 .76c-.12.28-.46.5-1.15.94l-9.334 5.93c-.79.51-1.19.76-1.52.74a.97.97 0 0 1-.72-.39"
      />
      <rect
        width={16}
        height={2}
        x={4}
        y={78}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={32}
        height={2}
        x={4}
        y={74}
        fill="currentColor"
        fillOpacity={0.32}
        opacity={0.6}
        rx={1}
      />
      <rect
        width={13}
        height={5}
        x={70.5}
        y={74.5}
        stroke="currentColor"
        strokeOpacity={0.14}
        rx={0.5}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M67.4 59a2.4 2.4 0 0 0-2.4 2.4v4.2a2.4 2.4 0 0 0 2.4 2.4h12.2a2.4 2.4 0 0 0 2.4-2.4v-4.2a2.4 2.4 0 0 0-2.4-2.4zm2.127 3.49a.54.54 0 0 1 .22.401h.884a1.22 1.22 0 0 0-.21-.686 1.34 1.34 0 0 0-.566-.462 2 2 0 0 0-.848-.166q-.477 0-.852.166t-.59.462a1.14 1.14 0 0 0-.211.693q-.003.484.317.769t.872.42l.475.119q.238.056.403.128.165.07.25.17.089.101.088.247a.44.44 0 0 1-.096.28.6.6 0 0 1-.27.19q-.173.067-.407.067-.24 0-.428-.072a.7.7 0 0 1-.3-.22.67.67 0 0 1-.127-.366h-.892q.01.47.228.79.22.318.609.48.392.162.92.162.534 0 .91-.16.38-.163.58-.454.203-.294.204-.694a1.2 1.2 0 0 0-.1-.484 1.1 1.1 0 0 0-.27-.367 1.6 1.6 0 0 0-.414-.262 2.8 2.8 0 0 0-.524-.17l-.392-.094a2 2 0 0 1-.268-.077 1 1 0 0 1-.222-.108.5.5 0 0 1-.151-.151.36.36 0 0 1-.05-.205q0-.141.082-.252a.54.54 0 0 1 .238-.172q.156-.064.382-.064.332 0 .526.143m2.674 2.47V66h-.907v-4.364h.907v2.333h.05l1.048-1.242h1.042l-1.214 1.418L74.403 66h-1.064l-.891-1.32zm2.585-2.233V66h.908v-3.273zm.109-.556q.144.135.347.134.203 0 .345-.134a.432.432 0 0 0 0-.648.48.48 0 0 0-.345-.136.5.5 0 0 0-.347.136.43.43 0 0 0-.143.322q0 .19.143.326m1.526.556v4.5h.907v-1.751h.028q.061.136.18.27a.9.9 0 0 0 .3.22q.184.087.45.087.372 0 .672-.191.303-.195.478-.57.177-.376.177-.924 0-.563-.181-.935a1.3 1.3 0 0 0-.484-.56 1.23 1.23 0 0 0-.66-.188q-.276 0-.46.093a.9.9 0 0 0-.3.23 1.2 1.2 0 0 0-.172.269h-.04v-.55zm.97 2.146a1.5 1.5 0 0 1-.082-.51q0-.291.081-.507a.74.74 0 0 1 .233-.332.6.6 0 0 1 .374-.117q.224 0 .378.121.154.122.232.337t.079.499q0 .285-.081.505a.76.76 0 0 1-.233.34.6.6 0 0 1-.374.122.6.6 0 0 1-.373-.12.76.76 0 0 1-.235-.338"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h88v88H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutubeSkippable;
